import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ThemeCtx = createContext(null);

export const THEMES = [
  { id: "theme-midnight-slate", name: "Midnight Slate", swatch: "#0B0D12", accent: "#F5F5F5" },
  { id: "theme-clariva-ivory", name: "Clariva Ivory", swatch: "#FDFDFC", accent: "#0A0A0A" },
  { id: "theme-emerald-executive", name: "Emerald Executive", swatch: "#061A14", accent: "#10B981" },
  { id: "theme-cerulean-trust", name: "Cerulean Trust", swatch: "#0F172A", accent: "#38BDF8" },
];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("clariva_theme") || "theme-clariva-ivory");
  const [mode, setMode] = useState(() => localStorage.getItem("clariva_mode") || "light");
  const [rtl, setRtl] = useState(() => localStorage.getItem("clariva_rtl") === "1");

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    root.setAttribute("data-mode", mode);
    root.setAttribute("dir", rtl ? "rtl" : "ltr");
    root.classList.toggle("dark", mode === "dark");
    localStorage.setItem("clariva_theme", theme);
    localStorage.setItem("clariva_mode", mode);
    localStorage.setItem("clariva_rtl", rtl ? "1" : "0");
  }, [theme, mode, rtl]);

  const syncServer = async (patch) => {
    try { await api.patch("/dashboard/layout", patch); } catch { /* ignore */ }
  };

  const value = {
    theme, setTheme: (t) => { setTheme(t); syncServer({ theme: t }); },
    mode, setMode: (m) => { setMode(m); syncServer({ mode: m }); },
    rtl, setRtl: (r) => { setRtl(r); syncServer({ rtl: r }); },
    toggleMode: () => { const nm = mode === "dark" ? "light" : "dark"; setMode(nm); syncServer({ mode: nm }); },
  };
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
